import { createResource } from '../utils/resource'

const checklistTemplateStore = createResource('checklistTemplate', {})

export default checklistTemplateStore